import React, { PureComponent, Component, ChangeEvent } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from "@material-ui/core/DialogContent";
import { dialogActions } from '../../actions/dialog.actions';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import { withStyles, createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles'

import { styles } from '../../containers/dockPadStyle'
import { compose } from 'redux'
import DialogActions from '@material-ui/core/DialogActions';
import { connect } from 'react-redux'
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { ThunkDispatch } from 'redux-thunk';
import { entityActions } from '../../actions/entity.actions';
import TextField from '@material-ui/core/TextField';
import { getRipTag } from '../../selectors/phaseplan.selector';
import { PhaseTag } from '../../models/PhaseTag';

import { green } from '@material-ui/core/colors';


export interface Props {
    isRipTagDialogOpen: boolean,
    classes: ClassNameMap,
    closeRipTagDialog: () => Promise<void>,
    ripTagValue: (tagId: string, tag: PhaseTag, ripAmount:number) => Promise<void>,
    ripTagId: string | null,
    tag: PhaseTag | null
}

const theme = createMuiTheme({
    palette: {
      primary: green,
    },
})

export interface ContentProps {
    onSubmit: (ripAmount: number) => any
    onClose: () => void,
    classes: ClassNameMap,
    tag: PhaseTag | null
}

type ContentState = {
    ripAmount: number,
    errored: boolean
}

class RipTagContent extends PureComponent<ContentProps, ContentState> { 
    
    readonly state = { 
        ripAmount: 0,
        errored: false
    }

    ripTag = () => {
        this.props.onSubmit(this.state.ripAmount)
    }

    onClose = () => {
        const { onClose } = this.props
        onClose()
    }

    handleChange = async (event:ChangeEvent<HTMLInputElement>) => {
        const { tag } = this.props
        if(!tag) { 
            const { onClose } = this.props
            onClose()
            return
        }
        const value:string = !!event.target.value ? event.target.value : "0"
        // tslint:disable-next-line: radix
        const ripAmount = parseInt(value)

        if(ripAmount >= tag.duration) {
            this.setState({
                errored: true
            })
            return
        }

        this.setState({
            ripAmount,
            errored: false
        })
    };

    getErrorText = () => {
        const { errored } = this.state
        if(!!errored) {
            return "Rip Amount must be less than duration"
        }
    }

    ripSummary = () => {
        const { tag } = this.props
        const { ripAmount } = this.state

        const duration = !!tag ? tag.duration : 0
        if(ripAmount === 0) {
            return "This will not cause a rip"
        }

        return `This will create two tags with ${duration - ripAmount} and ${ripAmount} duration`
    }
    

    render() {
        const { classes } = this.props
        const { ripAmount, errored } = this.state
        return (
            <React.Fragment>
                <DialogContent>
                    <div className={classNames(classes.deleteDialog)}>
                        Are you sure you want to rip this tag?
                    </div>
                    <TextField 
                        helperText={this.getErrorText()} 
                        error={errored} 
                        fullWidth={true} 
                        value={ripAmount}  
                        onChange={this.handleChange} 
                        label="Tear Amount" 
                        margin="dense" 
                    />
                    <div className={classNames(classes.deleteDialog)}>
                        {this.ripSummary()}
                    </div>
                </DialogContent>
                <MuiThemeProvider theme={theme}>
                    <DialogActions>
                            <Button onClick={this.onClose} color="secondary"> Cancel </Button>
                            <Button onClick={this.ripTag} color="primary">Rip</Button>
                    </DialogActions>
                </MuiThemeProvider>
            </React.Fragment>
        )
    }
}

const RipTagDialog: React.FunctionComponent<Props> =
    ({ isRipTagDialogOpen, classes, closeRipTagDialog, ripTagValue, ripTagId, tag }) => {
        
        const closeDialog = () => {
            return async () => {
                closeRipTagDialog()
            }
        }

        const ripTag = async (ripAmount: number) => {
            if (!ripTagId || !tag) {
                return
            }

            ripTagValue(ripTagId, tag, ripAmount)
            closeRipTagDialog()
        }

        return (
            <Dialog
                open={isRipTagDialogOpen}
                onBackdropClick={closeDialog()}
            >
                <RipTagContent tag={tag} classes={classes} onSubmit={ripTag} onClose={closeRipTagDialog} />
            </Dialog>
        )
    }

const mapStateToProps = (state: any) => ({
    isRipTagDialogOpen: !!state.dialogReducer.ripTagId,
    ripTagId: state.dialogReducer.ripTagId,
    tag: getRipTag(state)
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
        closeRipTagDialog: () => dispatch(dialogActions.closeRipTagDialog()),
        ripTagValue: (tagId: string, tag: PhaseTag, ripAmount:number) => 
            dispatch(entityActions.ripTag(tagId, tag, ripAmount)),
    }
};
export default compose(
    withStyles(styles, { withTheme: true }),
    connect(mapStateToProps, mapDispatchToProps),
)(RipTagDialog);



// WEBPACK FOOTER //
// ./src/components/Dialogs/RipTagDialogContainer.tsx